interface SaneHTML {
  __html: string
}

/**
 * It takes a string and replaces all it's instances of `&gt;` and `&lt;` with `>` and `<` respectively.
 *
 * @param string - The string to be sanitized.
 * @returns An object with the sanitized string.
 */
export const sanitizeHTML = (string: string): SaneHTML => {
  return {
    __html: string
      .replaceAll('&gt;', '>')
      .replaceAll('&lt;', '<')
      .replaceAll('&amp;gt;', '>')
      .replaceAll('&amp;lt;', '<'),
  }
}
